export default __webpack_public_path__ + "0213c85a12ee7c002b2f493e999924e4.png";